module.exports = "<div> <div class=get-file> <span>请上传本地照片：</span> <a class=post-btn> <input type=file class=select-pic>选择文件 </a> </div> <div class=container-position> <div class=avatar-container> </div> </div> <div class=canvas-box> <canvas class=avatar-result-square width=64px height=64px></canvas> </div> <div class=bottom-box> <span class=save-avatar>确定</span> <span class=set-cancel>取消</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/main/personal-settings/set-avatar/set-avatar.html
// module id = 2083
// module chunks = 50